import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { defaultArchivedSearch } from "@/features/projects/projects-search-schema"

export const Route = createFileRoute("/_authenticated/settings/projects")({
  beforeLoad: ({ location }) => {
    const p = location.pathname.replace(/\/$/, "")
    if (p === "/settings/projects") {
      throw redirect({ to: "/settings/projects/archived", search: defaultArchivedSearch })
    }
  },
  component: () => <Outlet />,
})
